export const initial_apiKey = {
  Codigo: null,
  Descripcion: null,
  ApiKey: null,
};
